<template>
  <div class="ScTable">
    <el-table
      ref="elTable"
      header-cell-class-name="table-header-cell"
      header-row-class-name="table-header-row"
      cell-class-name="table-cell"
      :row-class-name="customRowClassName"
      :data="data"
      v-bind="bindOptions"
      v-on="$listeners"
    >
      <el-table-column
        width="55px"
        align="center"
        fixed="left"
        v-if="isSelection"
        :resizable="false"
        ref="table"
      >
        <template slot="header" slot-scope="scope">
          <el-checkbox
            :disabled="data.length == 0"
            :data-scope="scope"
            :value="checkAll"
            @change="onSelectionChangeAll"
          ></el-checkbox>
        </template>
        <template slot-scope="scope">
          <el-checkbox
            :disabled="!selectable(scope.row, scope.$index)"
            :value="selection.includes(scope.row[rowKey])"
            @change="v => onSelectionChange(scope.row, v)"
          >
          </el-checkbox>
        </template>
      </el-table-column>
      <el-table-column
        :resizable="false"
        :label="sortText"
        type="index"
        v-if="isIndex"
        width="80px"
        align="center"
      ></el-table-column>
      <template v-for="item in tableColumns">
        <TableColumn :column="item">
          <!-- 将父组件的同名 slot 传递给 TableColumn -->
          <template v-for="(_, slot) in $scopedSlots" v-slot:[slot]="scope">
            <slot :name="slot" v-bind="scope" />
          </template>
        </TableColumn>
        <!-- <el-table-column
          :key="index"
          v-bind="item"
          :resizable="false"
          v-if="checkShow(item)"
          :align="item.align || 'center'"
        >
          <template slot="header">
            <slot name="header">
              <span v-if="item.required" class="dangerColor">*</span>
              <span :class="item.headerClass || ''">{{ item.label }}</span>
            </slot>
          </template>
          <template slot-scope="scope">
            <slot :name="item.prop" v-bind="scope">
              <span :class="[handleClass(scope, item)]">
                {{ handleRender(scope, item) | formatValue }}</span
              >
            </slot>
          </template>
        </el-table-column> -->
      </template>
      <slot name="append"></slot>
      <!-- 默认插槽内容 -->
      <slot></slot>
    </el-table>
    <div v-if="showPagination" class="page-wrap mt-4">
      <pagi
        :page="query.page"
        :pageSize="query.page_size"
        :count="total"
        @pageChange="pagination"
      ></pagi>
    </div>
  </div>
</template>

<script>
import pagi from "@/components/pagi/pagi";
import TableColumn from './modules/columns.vue';
import { cloneDeep, uniqBy } from "lodash";
export default {
  props: {
    total: {
      type: Number,
      default: () => 0
    },
    columns: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    border: {
      type: Boolean,
      default: true
    },
    selection: {
      type: Array,
      default: () => []
    },
    selectRows: {
      type: Array,
      default: () => []
    },
    rowKey: {
      type: String,
      default: "id"
    },
    selectable: {
      type: Function,
      default: () => {
        return true;
      }
    },
    isSelection: {
      type: Boolean,
      default: false
    },
    query: {
      type: Object,
      default: () => {}
    },
    showCustom: {
      type: Boolean,
      default: false
    },
    isIndex: {
      type: Boolean,
      default: false
    },
    sortText: {
      type: String,
      default: "排序"
    },
    rowClassName: {
      type: Function | String,
      default: ""
    },
    showPagination: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    bindOptions() {
      const { columns, data, border } = this.$props;
      console.log(this.$attrs);

      return Object.assign(this.$attrs, { columns, data, border });
    },
    checkAll() {
      if (this.data.length == 0 || this.selection.length == 0) {
        return false;
      }
      const result = this.data.filter(
        e => !this.selection.includes(e[this.rowKey])
      );
      return result.length === 0;
    },
    queryParams: {
      get() {
        return this.query;
      },
      set(v) {
        this.$emit("update:query", v);
      }
    }
  },
  components: {
    pagi, TableColumn
    
  },
  data() {
    return {
      tableColumns: [],
      showBar: false
    };
  },
  mounted() {
    this.initColumns();
    this.doLayout();
  },
  watch: {
    columns: {
      deep: true,
      handler() {
        this.initColumns();
        this.doLayout();
      }
    },
    data: {
      deep: true,
      handler() {
        this.doLayout();
      }
    }
  },
  methods: {
    customRowClassName({ row, rowIndex }) {
      if (typeof this.rowClassName === "function") {
        return this.rowClassName(row, rowIndex);
      }
      return this.rowClassName;
    },
    initColumns() {
      this.tableColumns = cloneDeep(this.columns);
    },
    doLayout() {
      this.$nextTick(() => {
        if (this.$refs.elTable && typeof this.$refs.elTable.doLayout === "function") {
          this.$refs.elTable.doLayout();
        }
      });
    },
    onSelectionChange(row, value) {
      if (value) {
        const keys = [...this.selection, row[this.rowKey]];
        const rows = [...this.selectRows, row];
        this.handleUpdateSelection(keys, rows);
      } else {
        const keys = this.selection.filter(v => v !== row[this.rowKey]);
        const rows = this.selectRows.filter(
          v => v[this.rowKey] !== row[this.rowKey]
        );
        this.handleUpdateSelection(keys, rows);
      }
    },
    onSelectionChangeAll(value) {
      const selection = this.data.map(item => item[this.rowKey]);
      const selectRows = cloneDeep(this.data);
      if (value) {
        const keys = [...new Set([...this.selection, ...selection])];
        const rows = [
          ...uniqBy([...this.selectRows, ...selectRows], this.rowKey)
        ];
        this.handleUpdateSelection(keys, rows);
      } else {
        const keys = this.selection.filter(e => !selection.includes(e));
        const rows = this.selectRows.filter(
          e => !selection.includes(e[this.rowKey])
        );
        this.handleUpdateSelection(keys, rows);
      }
    },
    handleUpdateSelection(value, data) {
      this.$emit("update:selection", value);
      this.$emit("update:selectRows", data);
    },
    handleRender({ row, $index }, { prop, formatData }) {
      if (formatData) {
        return formatData(row, $index);
      }
      return row[prop];
    },
    handleClass({ row, $index }, { rowClass }) {
      if (rowClass) {
        return rowClass(row, $index);
      }
      return "";
    },
    checkShow(opt) {
      return opt.show ? opt.show() : true;
    },
    pagination(page) {
      this.$emit("update:query", { ...this.query, page });
      this.$emit("loadPage");
    },
    onScrollBarChange() {
      this.showBar = !this.showBar;
    }
  },
  filters: {
    formatValue(value) {
      if (value || value === 0) {
        if (typeof value === "object") {
          let res = [];
          if (Array.isArray(value)) {
            res = value;
          } else {
            res = Object.values(value);
          }
          return res.length === 0 ? "--" : value;
        } else {
          if (value === "null" || value === "undefined" || value === "NaN") {
            return "--";
          }
          return value;
        }
      }
      return "--";
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .table-cell {
  background-color: #FFF;
}
/deep/ .el-table thead.is-group th.el-table__cell {
  background-color: #FFF;
}
</style>
